import * as React from 'react';
// this needs to be a function instead of a component since MUI derives the value by mapping over the first layer of children.
export var renderSelectOptions = function (_a) {
    var options = _a.options, value = _a.value;
    return options.map(function (option) { return (React.createElement("option", { key: option.value, value: option.value, "aria-selected": option.value === value, disabled: option.disabled, hidden: option.hidden }, option.text)); });
};
